import { IonContent, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLoading, IonPage, IonRefresher, IonRefresherContent, useIonViewDidEnter } from '@ionic/react';
import BeautyStars from 'beauty-stars';
import { checkmarkCircleOutline, chevronForwardOutline, helpCircleOutline, listOutline, timeOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { listaProjeto, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import ClientePageHeader from '../../../../../components/ClientePageHeader';
import { valorPedidoFormatado } from '../OrdensDetalhes/PedidoResumo';
import './Ordens.css';

const Ordens: React.FC = () => {
  const history = useHistory<any>();
  const [arrayProjetos, setArrayProjetos] = useState<any>([]);
  const [chamadaRealizada, setChamadaRealizada] = useState(false);
  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [projetopk, setProjetopk] = useState('');
  const [showLoading, setShowLoading] = useState(true);
  const { setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    const confirmation = history.location.state;
    if (confirmation?.pedidoEnviado) history.replace({ ...history.location, state: {} });
    setChamadaRealizada(false);
    loadItens();
    window.localStorage.setItem('compartilhado', 'false');
    setEsconderMenu(false);
  });

  function carregarDetalhes(value: any) {
    setChamadaRealizada(false);
    history.push('ordens/ordensdetalhes', {
      projetoid: value.pk.replaceAll(/#/g, '%23'),
      configs: JSON.stringify(value.configWorkflow), abrirInserirAgendamento: false
    });
  }

  const loadItens = () => {
    if (!chamadaRealizada) { setChamadaRealizada(true); carregarProjetos(); }
    if (!arrayProjetos?.length) return <div className="ordens-empty" role="status"><IonIcon icon={listOutline} aria-hidden="true" /><p>Aguarde, em instantes teremos novidades para você.</p></div>;
    return arrayProjetos.map((value: any, index: number, arr: any[]) => {
      const ativo = value.status === 'Ativo';
      const encerrado = value.status === 'Encerrado';
      const situacao = ativo ? 'Em andamento' : encerrado ? 'Encerrado' : value.status || 'Situação não informada';
      const data = new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10);
      const exibirData = index === 0 || data !== new Date(arr[index - 1].dataCadastro).toLocaleString('pt-BR').substring(0, 10);
      return <React.Fragment key={value.pk || value.id || index}>
        {exibirData && <h2 className="ordens-date">{data === new Date().toLocaleString('pt-BR').substring(0, 10) ? 'Hoje' : data}</h2>}
        <article className={`ordens-card${ativo ? ' ordens-card-active' : ''}${encerrado ? ' ordens-card-closed' : ''}`} aria-label={`${value.empresaNome || 'não identificado'}, ${value.nomeProjeto}, ${situacao}`}>
          <button type="button" className="ordens-card-link" aria-label={`Abrir pedido ${value.nomeProjeto} de ${value.empresaNome || 'não identificado'}`} onClick={() => carregarDetalhes(value)}>
            <div className="ordens-card-heading"><h3>{value.empresaNome || 'não identificado'}</h3><IonIcon icon={chevronForwardOutline} aria-hidden="true" /></div>
            <p className="ordens-number">{value.servicoTipo || 'Projeto'}: {value.nomeProjeto}</p>
            <div className="ordens-card-situation"><span className="ordens-status"><IonIcon icon={ativo ? timeOutline : encerrado ? checkmarkCircleOutline : helpCircleOutline} aria-hidden="true" />{situacao}</span><strong>{value.statusWorkflow || 'não identificado'}</strong></div>
            {value.avaliacaoCliente ? <div className="ordens-rating"><BeautyStars size="16px" value={value.avaliacaoCliente} editable={false} /></div> : null}
            {(value.produtos?.length > 0 || value.valorTotal != null) && <div className="ordens-card-summary"><span>{value.produtos?.length > 0 ? `${value.produtos.length} ${value.produtos.length === 1 ? 'item' : 'itens'}` : ''}</span>{value.valorTotal != null && <strong>{valorPedidoFormatado(value.valorTotal)}</strong>}</div>}
          </button>
        </article>
      </React.Fragment>;
    });
  };
  function carregarProjetos() {
    const consultar = async () => {

      requestService(listaProjeto.url, {
        method: listaProjeto.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          setArrayProjetos(response.Items);
          if (response.LastEvaluatedKey) {
            setProjetopk(response.LastEvaluatedKey.pk);
            setDesabilitarInfiniteScroll(false);
          }
          else {
            setProjetopk("");
            setDesabilitarInfiniteScroll(true);
          }
          setShowLoading(false);
        },
        (error: any) => {
          setShowLoading(false);
        });
    }

    consultar();
  }

  async function carregarMaisProjetos($event: CustomEvent<void>) {

    await carregarMaisProjetosChamada().then(() => {
      console.log("terminou resultados");
    });
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function carregarMaisProjetosChamada() {

    requestService(listaProjeto.url + "?pk=" + projetopk, {
      method: listaProjeto.method,
      headers: [
        ["token", window.localStorage.getItem("token")],
        ["perfil", window.localStorage.getItem("perfil")],
        ["marca", window.localStorage.getItem("marca") || ""],
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(arrayProjetos.length);
        for (let i = 0; i < response.Items.length; i++) {
          console.log("resultados");
          arrayProjetos.push(response.Items[i]);
        }
        console.log(arrayProjetos.length);
        if (response.LastEvaluatedKey) {
          setProjetopk(response.LastEvaluatedKey.pk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setProjetopk("");
          setDesabilitarInfiniteScroll(true);
          console.log("finalizou");
        }
      },
      (error: any) => {
        console.log(error);
        if (error.status === 426) { // atualizar versao
          history.replace("/atualizar");
        }
        else if (error !== 408) {
          history.replace("/primeiroacesso/");
        }
      });
  }

  function doRefresh(event: any) {
    carregarProjetos();
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }

  return <IonPage className="ordens-screen">
    <ClientePageHeader title={window.localStorage.getItem('servicoTipoPlural') || 'Meus Pedidos'} />
    <IonContent className="Ordens ordens-page">
      <div className="ordens-lista">{loadItens()}</div>
      <IonRefresher slot="fixed" onIonRefresh={doRefresh}><IonRefresherContent /></IonRefresher>
      <IonInfiniteScroll threshold="100px" onIonInfinite={(e: CustomEvent<void>) => carregarMaisProjetos(e)} position="bottom" disabled={desabilitarInfiniteScroll}><IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais operações..." /></IonInfiniteScroll>
      <IonLoading cssClass="my-custom-class" isOpen={showLoading} onDidDismiss={() => setShowLoading(false)} spinner="circles" />
    </IonContent>
  </IonPage>;
};
export default Ordens;
